import { Injectable } from '@angular/core';
import { IAdressResponse } from '../models/adress.model';
import { Observable } from 'rxjs';
import { ROUTES } from '../constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdressService {
  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Get all adress by service
   * @returns
   */
  getAll(id: number): Observable<IAdressResponse> {
    return this.httpClient.get<IAdressResponse>(`${ROUTES.adressService.forService}/${id}`);
  }

}
